import React, { useEffect, useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialMode?: 'login' | 'signup';
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose, initialMode = 'login' }) => {
  const [mode, setMode] = useState<'login' | 'signup'>(initialMode);

  useEffect(() => {
    if (!isOpen) return;
    setMode(initialMode);
    const handleEscape = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleEscape);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEscape);
    };
  }, [initialMode, isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="auth-dialog" role="dialog" aria-modal="true" aria-label={mode === 'login' ? 'Anmelden' : 'Konto erstellen'}>
      <button type="button" className="auth-dialog-backdrop" onClick={onClose} aria-label="Anmeldedialog schließen" />
      <div className="auth-dialog-panel">
        <div className="auth-dialog-brand">
          <div className="grid h-11 w-11 place-items-center rounded-xl bg-white text-slate-950 shadow-lg shadow-black/20">
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM15 14h2v2h-2zM19 14h1v3h-3v3h-3v-2" /></svg>
          </div>
          <div className="mt-auto"><p className="text-xs font-semibold uppercase tracking-[0.16em] text-blue-300">RedirectQR Workspace</p><h3 className="mt-3 text-3xl font-semibold leading-tight tracking-[-0.04em] text-white">Alle Ziele an einem Ort steuern.</h3><p className="mt-4 text-sm leading-6 text-slate-400">Erstelle dynamische Codes, aktualisiere Live-Weiterleitungen und behalte Scans im Blick.</p></div>
        </div>
        <div className="relative max-h-[calc(100vh-2rem)] overflow-y-auto bg-white p-6 sm:p-8">
          <button type="button" onClick={onClose} className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-lg text-xl text-slate-400 transition hover:bg-slate-100 hover:text-slate-700" aria-label="Schließen">×</button>
          <div className="mx-auto max-w-sm pt-4">
            {mode === 'login' ? <LoginForm onToggleMode={() => setMode('signup')} onClose={onClose} /> : <SignupForm onToggleMode={() => setMode('login')} onClose={onClose} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
